import { render, staticRenderFns } from "./AiFilmMakerIcon.vue?vue&type=template&id=00a460b6"
import script from "./AiFilmMakerIcon.vue?vue&type=script&lang=js"
export * from "./AiFilmMakerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports